import React from 'react';

const HoursTab = ({ formData, orderedDays, onChange }) => {
    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-medium font-montserrat text-gray-900 mb-4">Åbningstider</h2>
            
            {/* Add toggle for showing hours */}
            <div className="mb-6">
                <label className="flex items-center space-x-3">
                    <input
                        type="checkbox"
                        checked={formData.hours.showHours || false}
                        onChange={(e) => onChange('showHours', e.target.checked)}
                        className="w-4 h-4 text-amber-600 border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-700">Vis åbningstider på hjemmesiden</span>
                </label>
            </div>

            <div className="space-y-4">
                {orderedDays.map((day) => (
                    <div key={day} className="flex items-center space-x-4">
                        <label className="w-24 text-sm font-medium text-gray-700">{day}</label>
                        <input
                            type="text"
                            value={formData.hours[day] || ''}
                            onChange={(e) => onChange(`hours.${day}`, e.target.value)}
                            className="flex-1 border border-gray-300 rounded-md shadow-sm p-2"
                            placeholder="07:00 - 16:00"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HoursTab;